import api from "../../services/api";
import { mapMutations } from "vuex";

export default {
	components: {},

	data: function() {
		return {
			loading: true,
			//Localization
			isLocalizationSettingsInEditMode: false,
			// viewLocTypes: [
			// 	{ key: 0, value: "Mappa + Griglia Verticale"},
			// 	{ key: 1, value: "Mappa + Griglia Orizzontale"},
			// 	{ key: 2, value: "Griglia Orizzontale"},
			// ],
			locViewType: "0",
			locShowMapLeftGrid: true,
			locShowMapBottomGrid: false,
			locShowBottomGrid: false,
			locRefreshRealTimeMap: 300,
			saveLocSettingsRequest: null,

			//trips
			isTripsSettingsInEditMode: false,
			tripsShowMap: false,
			tripsShowBottmoGrid: false,
			saveTripsSettingsRequest: null,

			//diagnostic
			isDiagnosticSettingsInEditMode: false,
			diagnosticShowMap: false,
			diagnosticShowBottomGrid: false,
			saveDiagnosticSettingsRequest: null,

			//alarms
			isAlarmsSettingsInEditMode: false,
			alarmsShowMap: false,
			alarmsShowBottomGrid: false,
			saveAlarmsSettingsRequest: null,

			//Generals
			isGeneralSettingsInEditMode: false,
			isInEditMode: false,
			saveGeneralSettingsRequest: null,
			defaultPageSize: 25,
			showTrafficOnMap: false,
			showSatOnMap: false,
			showPoiOnMap: false,
			retantionBoxData: false,
			showExportData: false,
			mobility_manager_email: ""
		};
	},

	created() {
		this.getData();
	},

	/* metodi */
	methods: {
		...mapMutations(["settingsFleeRun"]),
		getData() {
			var self = this;
			api.getViewConfig("globals ").then(res => {
				self.defaultPageSize = res.defaultPageSize;
				self.showTrafficOnMap = res.viewTraffic;
				self.showSatOnMap = res.viewSatellite;
				self.showPoiOnMap = res.viewPoi;
				self.showExportData = res.canExportGridData;
				self.mobility_manager_email = res.mobility_manager_email;

				var locViewType = res.geoLocation.viewType;
				if (locViewType == "map, horizontalGrid") {
					self.locViewType = "1";
				} else if (locViewType == "horizontalGrid") {
					self.locViewType = "2";
				} else {
					self.locViewType = "0";
				}
				self.locRefreshRealTimeMap = res.geoLocation.refreshInterval;

				if (res.trips.viewType.indexOf("map") >= 0) {
					self.tripsShowMap = true;
				}
				if (res.trips.viewType.indexOf("horizontalGrid") >= 0) {
					self.tripsShowBottmoGrid = true;
				}

				if (res.diagnosis.viewType.indexOf("map") >= 0) {
					self.diagnosticShowMap = true;
				}
				if (res.diagnosis.viewType.indexOf("horizontalGrid") >= 0) {
					self.diagnosticShowBottomGrid = true;
				}

				if (res.alarms.viewType.indexOf("map") >= 0) {
					self.alarmsShowMap = true;
				}
				if (res.alarms.viewType.indexOf("horizontalGrid") >= 0) {
					self.alarmsShowBottomGrid = true;
				}

				self.loading = false;
			});
		},
		switchEditMode() {
			this.isInEditMode = !this.isInEditMode;
			if (!this.isInEditMode) this.resetAllEditMode();

			this.saveDiagnosticSettingsRequest = null;
		},
		switchGeneralSettingsEditMode() {
			this.isGeneralSettingsInEditMode = !this.isGeneralSettingsInEditMode;
			if (!this.isGeneralSettingsInEditMode) this.resetAllEditMode();

			this.saveDiagnosticSettingsRequest = null;
		},
		switchLocEditMode() {
			this.isLocalizationSettingsInEditMode = !this.isLocalizationSettingsInEditMode;
			if (!this.isLocalizationSettingsInEditMode) this.resetAllEditMode();

			this.saveLocSettingsRequest = null;
		},
		switchDiagnosticEditMode() {
			this.isDiagnosticSettingsInEditMode = !this.isDiagnosticSettingsInEditMode;
			if (!this.isDiagnosticSettingsInEditMode) this.resetAllEditMode();

			this.saveDiagnosticSettingsRequest = null;
		},
		switchTripsEditMode() {
			this.isTripsSettingsInEditMode = !this.isTripsSettingsInEditMode;
			if (!this.isTripsSettingsInEditMode) this.resetAllEditMode();

			this.saveTripsSettingsRequest = null;
		},
		switchAlarmsEditMode() {
			this.isAlarmsSettingsInEditMode = !this.isAlarmsSettingsInEditMode;
			if (!this.isAlarmsSettingsInEditMode) this.resetAllEditMode();

			this.saveAlarmsSettingsRequest = null;
		},

		resetAllEditMode() {
			// this.isGeneralSettingsInEditMode = false;
			// this.isLocalizationSettingsInEditMode = false;
			// this.isDiagnosticSettingsInEditMode = false;
			// this.isTripsSettingsInEditMode = false;
			// this.isAlarmsSettingsInEditMode = false;
			this.isInEditMode = false;

			this.getData();
		},

		saveSettings() {
			var self = this;
			var locViewType = "";

			if (this.locViewType == 0) locViewType = "map, verticalGrid";
			if (this.locViewType == 1) locViewType = "map, horizontalGrid";
			if (this.locViewType == 2) locViewType = "horizontalGrid";

			var diagnosticViewType = [];
			if (this.diagnosticShowMap) diagnosticViewType.push("map");
			if (this.diagnosticShowBottomGrid) diagnosticViewType.push("horizontalGrid");

			var diagnosticViewTypeStr = diagnosticViewType.join().replace(",", ", ");

			var tripsViewType = [];
			if (this.tripsShowMap) tripsViewType.push("map");
			if (this.tripsShowBottmoGrid) tripsViewType.push("horizontalGrid");

			var tripsViewTypeStr = tripsViewType.join().replace(",", ", ");

			var alarmsViewType = [];
			if (this.alarmsShowMap) alarmsViewType.push("map");
			if (this.alarmsShowBottomGrid) alarmsViewType.push("horizontalGrid");

			var alarmsViewTypeStr = alarmsViewType.join().replace(",", ", ");

			var data = {
				geoLocation: {
					viewType: locViewType,
					refreshInterval: this.locRefreshRealTimeMap
				},
				diagnosis: {
					viewType: diagnosticViewTypeStr
				},
				trips: {
					viewType: tripsViewTypeStr
				},
				alarms: {
					viewType: alarmsViewTypeStr
				},
				mobility_manager_email: self.mobility_manager_email
			};

			this.saveGeneralSettingsRequest = api
				.setCompanyConfig(data)
				.then(res => {
					self.resetAllEditMode();
					self.settingsFleeRun(data);
				})
				.finally(_ => {
					self.saveGeneralSettingsRequest = null;
				});
		},

		saveLocalizationSettings() {
			var self = this;
			var locViewType = "";

			if (this.locViewType == 0) locViewType = "map, verticalGrid";
			if (this.locViewType == 1) locViewType = "map, horizontalGrid";
			if (this.locViewType == 2) locViewType = "horizontalGrid";

			var data = {
				geoLocation: {
					viewType: locViewType
				}
			};

			this.saveLocSettingsRequest = api
				.setCompanyConfig(data)
				.then(res => {
					self.resetAllEditMode();
				})
				.finally(_ => {
					self.saveLocSettingsRequest = null;
				});
		},

		saveDiagnosticSettings() {
			var self = this;
			var diagnosticViewType = [];

			if (this.diagnosticShowMap) diagnosticViewType.push("map");
			if (this.diagnosticShowBottomGrid) diagnosticViewType.push("horizontalGrid");

			var diagnosticViewTypeStr = diagnosticViewType.join().replace(",", ", ");

			var data = {
				diagnosis: {
					viewType: diagnosticViewTypeStr
				}
			};

			this.saveDiagnosticSettingsRequest = api
				.setCompanyConfig(data)
				.then(res => {
					self.resetAllEditMode();
				})
				.finally(_ => {
					self.saveDiagnosticSettingsRequest = null;
				});
		},

		saveTripsSettings() {
			var self = this;
			var tripsViewType = [];

			if (this.tripsShowMap) tripsViewType.push("map");
			if (this.tripsShowBottmoGrid) tripsViewType.push("horizontalGrid");

			var tripsViewTypeStr = tripsViewType.join().replace(",", ", ");

			var data = {
				trips: {
					viewType: tripsViewTypeStr
				}
			};

			this.saveTripsSettingsRequest = api
				.setCompanyConfig(data)
				.then(res => {
					self.resetAllEditMode();
				})
				.finally(_ => {
					self.saveTripsSettingsRequest = null;
				});
		},

		saveAlarmsSettings() {
			var self = this;
			var alarmsViewType = [];

			if (this.alarmsShowMap) alarmsViewType.push("map");
			if (this.alarmsShowBottomGrid) alarmsViewType.push("horizontalGrid");

			var alarmsViewTypeStr = alarmsViewType.join().replace(",", ", ");

			var data = {
				alarms: {
					viewType: alarmsViewTypeStr
				}
			};

			this.saveAlarmsSettingsRequest = api
				.setCompanyConfig(data)
				.then(res => {
					self.resetAllEditMode();
				})
				.finally(_ => {
					self.saveAlarmsSettingsRequest = null;
				});
		}
	},

	/* visualizzazione risultati */
	computed: {}
};
